"use strict";
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropzone from "react-dropzone";
import XLSX from "xlsx";
import Pagination from "react-js-pagination";
import { Modal } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import { openImportExhibitorModal, importExhibitor } from "ActionsExhibitors";
import {
  NEW_IMAGE_PATH,
  validatePhoneNumbers,
  validateEmail,
  validateSocialMediaUrl,
} from "Constants";
import ExhibitorCell from "./exhibitor-cell";
// import PaginationComponent from 'PaginationComponent';
import AppIcons from "AppIcons";
import LocaleStrings from "Languages";

const per_page_row = 10;
var interval;

class ImportExhibitorDialog extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);

    this.state = {
      accept:
        "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      files: [],
      previewFile: "",
      loading: false,
      processingData: false,
      hasData: false,
      importedusers: [],
      hasError: false,
      hasDataError: false,
      errorMessage: "",
      selectedPage: 1,
      paginatedData: {
        page: 0,
        per_page: 0,
        total: 0,
        total_pages: 0,
        data: [],
      },
      usersCount: 0,
      duplicateData: "update",
    };
  }

  componentDidMount() {
    // this.props.fetchBulkUplodedLeftUsers(this.props.session);
    // interval = setInterval(() => {
    //   this.props.fetchBulkUplodedLeftUsers(this.props.session);
    // }, 15000);
  }

  componentWillUnmount() {
    this.clearInterval(interval);
  }

  clearInterval = () => {
    clearInterval(interval);
  };

  openModal() {
    this.retry();
    this.setState({ loading: false });
    this.props.openImportExhibitorModal(true);
  }

  closeModal = () => {
    this.props.openImportExhibitorModal(false);
    this.retry();
  };

  onSubmitForm(values) {}

  onDrop = (files) => {
    this.setState({
      files,
    });

    let file = files[0];
    var Papa = require("papaparse/papaparse.min.js");
    if (file && file.type === "text/csv") {
      Papa.parse(file, {
        skipEmptyLines: true,
        complete: function (results, file) {
          if (results.errors.length === 0) this.processCSV(results.data);
          else {
            this.setState({
              hasError: true,
              errorMessage: LocaleStrings.user_import_validation1,
            });
          }
        }.bind(this),
        error: function (error, reason) {
          this.setState({
            hasError: true,
            errorMessage: LocaleStrings.user_import_validation1,
          });
        },
      });
    } else {
      //debugger;
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        /* Update state */
        //this.setState({ data: data, cols: make_cols(ws['!ref']) });

        if (data.length === 0) {
          this.setState({
            hasError: true,
            errorMessage: LocaleStrings.user_import_validation1,
          });
        } else {
          this.processXLS(data);
        }
      };
      if (rABS) reader.readAsBinaryString(file);
      else reader.readAsArrayBuffer(file);
    }
  };

  processXLS = (result) => {
    this.processCSV(result);
  };

  processCSV = (result) => {
    this.setState({ processingData: true });

    var header = result[0];
    if (header && header.length >= 14) {
      var nameHeader = header[0].toString().trim();

      if (nameHeader === "name") {
        var newArray = _.drop(result, 1);
        var modifiedArr = [];
        newArray.map((user, id) => {
          var name = user[0] && user[0] != "" ? user[0].toString().trim() : "";

          if (user.length > 0 && name) {
            modifiedArr.push({
              name: name,
              booth: user[1] && user[1] != "" ? user[1] : "",
              about: user[2] && user[2] != "" ? user[2] : "",
              logo: user[3] && user[3] != "" ? user[3].toString().trim() : "",
              banner: user[4] && user[4] != "" ? user[4].toString().trim() : "",
              contactperson:
                user[5] && user[5] != "" ? user[5].toString().trim() : "",
              phonenumber: user[6] && user[6] != "" ? user[6] : "",
              email: user[7] && user[7] != "" ? user[7].toLowerCase() : "",
              weblink: user[8] && user[8] != "" ? user[8] : "",
              facebook: user[9] && user[9] != "" ? user[9] : "",
              linkedin: user[10] && user[10] != "" ? user[10] : "",
              twitter: user[11] && user[11] != "" ? user[11] : "",
              instagram: user[12] && user[12] != "" ? user[12] : "",
              whatsapp: user[13] && user[13] != "" ? user[13] : "",
              rowno: id + 2,
            });
          }
        });

        var ErrorDataArr = [];
        // Validate email and phone
        var invalidEmails = [];
        var invalidPhone = [];
        modifiedArr.map((obj, id) => {
          var user = JSON.parse(JSON.stringify(obj));
          var errors = [];

          if (user.name == "") {
            errors.push(
              LocaleStrings.exhibitor_th_name +
                " " +
                LocaleStrings.small_required
            );
          }
          if (user.email != "") {
            var validated = validateEmail(user.email);
            if (!validated) {
              errors.push(LocaleStrings.invalid_email);
            }
          }
          if (user.phonenumber) {
            var validated = validatePhoneNumbers(user.phonenumber);
            if (!validated) {
              errors.push(LocaleStrings.exhibitor_validation_phone_invalid);
            }
          }
          if (user.weblink && !validateSocialMediaUrl(user.weblink)) {
            errors.push(`${LocaleStrings.invalid_url}`);
          }
          if (user.facebook && !validateSocialMediaUrl(user.facebook)) {
            errors.push(`${LocaleStrings.invalid_facebook_url}`);
          }
          if (user.linkedin && !validateSocialMediaUrl(user.linkedin)) {
            errors.push(`${LocaleStrings.invalid_linkedin_url}`);
          }
          if (user.twitter && !validateSocialMediaUrl(user.twitter)) {
            errors.push(`${LocaleStrings.invalid_twitter_url}`);
          }
          if (user.instagram && !validateSocialMediaUrl(user.instagram)) {
            errors.push(`${LocaleStrings.invalid_instagram_url}`);
          }
          if (user.whatsapp && !validatePhoneNumbers(user.whatsapp)) {
            errors.push(`${LocaleStrings.invalid_whatsapp_no}`);
          }

          if (errors.length > 0) {
            // storing errors
            user.hasErrors = errors;
            ErrorDataArr.push(user);
          }
        });

        var pageNumber = 1;
        var dataArray = ErrorDataArr.length > 0 ? ErrorDataArr : modifiedArr;
        var paginatedData = this.getPaginatedItems(dataArray, pageNumber);
        this.setState({
          hasData: true,
          hasDataError: ErrorDataArr.length > 0,
          importedusers: ErrorDataArr.length > 0 ? ErrorDataArr : dataArray,
          selectedPage: pageNumber,
          paginatedData,
          usersCount:
            ErrorDataArr.length > 0 ? ErrorDataArr.length : dataArray.length,
        });

        // if (invalidEmails.length !== 0) {
        //   var invalidemailsdata = _.map(invalidEmails, "email");
        //   this.setState({
        //     hasError: true,
        //     errorMessage: `${
        //       LocaleStrings.user_import_validation2
        //     } [${invalidemailsdata.join(", ")}]`,
        //   });
        // } else if (invalidPhone.length !== 0) {
        //   var invalidsphonesdata = _.map(invalidPhone, "phonenumber");
        //   this.setState({
        //     hasError: true,
        //     errorMessage: `${
        //       LocaleStrings.general_import_validationphone
        //     } [${invalidsphonesdata.join(", ")}]`,
        //   });
        // } else if (modifiedArr.length == 0) {
        //   this.setState({
        //     hasError: true,
        //     errorMessage: LocaleStrings.general_import_validationdata,
        //   });
        // } else {
        //   this.setState({ hasData: true, importedusers: modifiedArr });
        //   var pageNumber = 1;
        //   var paginatedData = this.getPaginatedItems(modifiedArr, pageNumber);
        //   this.setState({
        //     selectedPage: pageNumber,
        //     paginatedData,
        //     usersCount: modifiedArr.length,
        //   });
        // }
      } else {
        this.setState({
          hasError: true,
          errorMessage: LocaleStrings.user_import_validation4,
        });
      }
    } else {
      this.setState({
        hasError: true,
        errorMessage: LocaleStrings.user_import_validation4,
      });
    }
  };

  renderUserList = () => {
    return this.state.paginatedData.data.map((user, id) => {
      return <ExhibitorCell key={id} user={user} />;
    });
  };

  importUser = () => {
    this.setState({ loading: true });
    this.props.importExhibitor(
      this.props.session,
      this.state.importedusers,
      this.state.duplicateData,
      (response) => {
        if (response.success === 0) {
          this.props.showError(LocaleStrings.exhibitor_import_validation5);
        } else {
          if (response.success === 1) {
            this.props.showSuccess(
              response.count + " " + LocaleStrings.exhibitor_message_imported
            );
            this.props.finishOperationsCallback();
          } else if (response.success === 2) {
            this.props.showSuccess(
              LocaleStrings.exhibitor_message_imported_nodata
            );
          }
          this.closeModal();
        }
        this.setState({ loading: false });
      }
    );
  };

  retry = () => {
    this.setState({
      processingData: false,
      hasData: false,
      hasError: false,
      hasDataError: false,
      errorMessage: "",
    });
  };

  getPaginatedItems = (items, page) => {
    var page = page || 1,
      per_page = 10,
      offset = (page - 1) * per_page,
      paginatedItems = _.drop(items, offset).slice(0, per_page);

    return {
      page: page,
      per_page: per_page,
      total: items.length,
      total_pages: Math.ceil(items.length / per_page),
      data: paginatedItems,
    };
  };

  // renderPaginationList() {
  //   var callback = (pageNumber) => {
  //     // debugger;
  //     if (this.state.selectedPage !== (pageNumber+1)) {
  //       var paginatedData=this.getPaginatedItems(this.state.importedusers,(pageNumber+1));
  //       this.setState({selectedPage:(pageNumber+1),paginatedData});
  //     }
  //   }
  //   var pageCount = this.state.paginatedData.total_pages;
  //   var paginationItems = [];
  //   for(var pageNumber = 0; pageNumber < pageCount; pageNumber++) {
  //     var isactive=(this.state.selectedPage === pageNumber+1);
  //     paginationItems.push(<PaginationComponent key={pageNumber} active={isactive} pageNumber={pageNumber} callback={callback}/>);
  //   }
  //   return paginationItems;
  // }

  paginationCallback = (pageNumber) => {
    if (this.state.selectedPage !== pageNumber) {
      var paginatedData = this.getPaginatedItems(
        this.state.importedusers,
        pageNumber
      );
      this.setState({ selectedPage: pageNumber, paginatedData });
    }
  };

  onOptionChange = (e) => {
    let clickedValue = e.target.value;

    this.setState({
      duplicateData: clickedValue,
    });
  };

  render() {
    //var {handleSubmit, pristine, reset, submitting, invalid} = this.props;

    var {
      accept,
      processingData,
      hasData,
      hasError,
      hasDataError,
      errorMessage,
      usersCount,
    } = this.state;
    var pageCount = this.state.paginatedData.total_pages;
    var count_user = usersCount > 0 ? usersCount : "";

    return (
      <div>
        <div className="">
          <Button
            type="button"
            className="btn-custom-blue schedule-add-button vertical-align-center"
            onClick={this.openModal}
          >
            <span className="font-icomoon i-custom-ms">
              {AppIcons.uploadericon}
            </span>
            &nbsp;
            {LocaleStrings.button_csv_xml_import}
          </Button>
        </div>
        <div>
          <Modal
            className="modal-container"
            show={this.props.showModal === true ? true : false}
            onHide={this.closeModal}
            animation={true}
            dialogClassName="modal-lg" // importExhibitorModal
            size={"xl"}
          >
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.exhibitor_import_header}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              {processingData ? (
                hasData ? (
                  <div className="imported-users">
                    {hasDataError ? (
                      <div className="custom-text1-primary-medium">
                        {LocaleStrings.user_import_error_rows_message}. Please
                        fix this row to add all users.
                      </div>
                    ) : (
                      ""
                    )}

                    <table
                      className="table"
                      style={{ overflowX: "auto", overflowY: "hidden" }}
                    >
                      <thead>
                        <tr>
                          <th>{LocaleStrings.exhibitor_table_list_rowno}</th>
                          <th>{LocaleStrings.exhibitor_table_list_name}</th>
                          <th>{LocaleStrings.exhibitor_table_list_booth}</th>
                          <th>
                            {LocaleStrings.exhibitor_table_list_description}
                          </th>
                          <th>{LocaleStrings.exhibitor_table_list_logo}</th>
                          <th>{LocaleStrings.exhibitor_table_list_banner}</th>
                          <th>
                            {LocaleStrings.exhibitor_table_list_contactperson}
                          </th>
                          <th>
                            {LocaleStrings.exhibitor_table_list_phonenumber}
                          </th>
                          <th>{LocaleStrings.exhibitor_table_list_email}</th>
                          <th>{LocaleStrings.exhibitor_table_list_website}</th>
                          <th>{LocaleStrings.exhibitor_table_list_facebook}</th>
                          <th>{LocaleStrings.exhibitor_table_list_linkedin}</th>
                          <th>{LocaleStrings.exhibitor_table_list_twitter}</th>
                          <th>
                            {LocaleStrings.exhibitor_table_list_instagram}
                          </th>
                          <th>{LocaleStrings.exhibitor_table_list_whatsapp}</th>
                        </tr>
                      </thead>
                      <tbody>{this.renderUserList()}</tbody>
                    </table>
                  </div>
                ) : hasError ? (
                  <div className="import-error">
                    <div>{errorMessage}</div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-danger text-uppercase user-add-btn"
                        onClick={this.retry}
                      >
                        <i className="fa fa-arrow-rotate-right pull-left import-retry"></i>{" "}
                        {LocaleStrings.button_retry}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>{LocaleStrings.exhibitor_message_processing_data}..</div>
                )
              ) : (
                <div className="form-group formdiv">
                  <Row>
                    <Col>
                      <div
                        className="imgPreview"
                        style={{ padding: "0px", marginLeft: -10 }}
                      >
                        <section>
                          <div className="dropzone">
                            <Dropzone
                              accept={accept}
                              onDrop={this.onDrop.bind(this)}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div
                                  {...getRootProps()}
                                  className="importdropbox"
                                >
                                  <input {...getInputProps()} />
                                  <div className="import-drop-text">
                                    <div>
                                      <img
                                        src={`${NEW_IMAGE_PATH}upload.png`}
                                      />
                                    </div>
                                    <div>
                                      {
                                        LocaleStrings.sponsor_import_text_click_drag_drop_1
                                      }{" "}
                                      <br />
                                      {
                                        LocaleStrings.sponsor_import_text_click_drag_drop_2
                                      }
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                          </div>
                        </section>
                      </div>
                    </Col>
                    <Col>
                      <div className="">
                        <div className="import-title">
                          {LocaleStrings.exhibitor_import_download_template}
                        </div>
                        <div className="import-subtitle">
                          {
                            LocaleStrings.exhibitor_import_download_template_subtitle1
                          }
                        </div>
                        <div style={{ marginTop: 10 }}>
                          <div className="import-option">
                            <a
                              className="users-link"
                              href="../../resource/exhibitorcsvtemplate.csv"
                              download
                            >
                              <img src={`${NEW_IMAGE_PATH}download.png`} />{" "}
                              <span className="import-option-button">
                                {LocaleStrings.exhibitor_import_sample_csv}
                              </span>
                            </a>
                          </div>
                          <div className="import-option">
                            <a
                              className="users-link"
                              href="../../resource/exhibitorxlstemplate.xls"
                              download
                            >
                              <img src={`${NEW_IMAGE_PATH}download.png`} />{" "}
                              <span className="import-option-button">
                                {LocaleStrings.exhibitor_import_sample_xls}
                              </span>
                            </a>
                          </div>
                          <div className="import-option">
                            <img
                              className="xls-sample-img"
                              src={`${NEW_IMAGE_PATH}exhibitor_xls.png`}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <div className="col-md-12 col-sm-12 import-notes">
                        <ul>
                          <li className="import-notes-title">
                            {LocaleStrings.notes}
                          </li>
                          {/* <li>- {LocaleStrings.speaker_import_note2}</li> */}
                          <li>- {LocaleStrings.column_header_format}</li>
                          <li>- {LocaleStrings.phone_format}</li>
                          <li>- {LocaleStrings.email_format}</li>
                          <li>- {LocaleStrings.exhibitor_import_note3}</li>
                          <li>- {LocaleStrings.date_format}</li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
              {!hasError && hasData && pageCount > 1 ? (
                // <div className="pull-right">
                //   <ul className="pagination">
                //     {this.renderPaginationList()}
                //   </ul>
                // </div>

                <Pagination
                  activePage={this.state.selectedPage}
                  itemsCountPerPage={per_page_row}
                  totalItemsCount={this.state.importedusers.length}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                />
              ) : null}
            </Modal.Body>
            {hasData && usersCount > 0 && !hasDataError ? (
              <Modal.Footer>
                <Row>
                  <Col sm={8}>
                    <Row>
                      <Col sm={6}>
                        {LocaleStrings.exhibitor_duplicate_datatext}
                      </Col>
                      <Col sm={3} style={{ fontSize: 13, textAlign: "right" }}>
                        <input
                          type="radio"
                          value="update"
                          name=""
                          checked={
                            this.state.duplicateData == "update" ? true : false
                          }
                          onChange={this.onOptionChange.bind(this)}
                        />{" "}
                        {LocaleStrings.exhibitor_overwrite}
                      </Col>
                      <Col sm={3} style={{ fontSize: 13 }}>
                        <input
                          type="radio"
                          value="insert"
                          name=""
                          checked={
                            this.state.duplicateData == "insert" ? true : false
                          }
                          onChange={this.onOptionChange.bind(this)}
                        />{" "}
                        {LocaleStrings.exhibitor_skip}
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={4}>
                    <Button
                      style={{ width: 225 }}
                      className="btn btn-custom-blue"
                      loading={this.state.loading}
                      type="button"
                      onClick={this.importUser.bind(this)}
                    >
                      {LocaleStrings.import} {count_user}{" "}
                      {LocaleStrings.exhibitor_button_text}
                    </Button>
                  </Col>
                </Row>
              </Modal.Footer>
            ) : (
              <Modal.Footer>
                <Button
                  className="btn btn-custom-white"
                  type="button"
                  onClick={this.closeModal}
                >
                  Close
                </Button>
              </Modal.Footer>
            )}
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.importExhibitorModal,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openImportExhibitorModal,
  importExhibitor,
})(ImportExhibitorDialog);
